// import React, { useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { useAuth } from "../context/AuthContext";
// import AuthLayout from "../components/auth/AuthLayout";

// const LoginPage = () => {
//   const { login } = useAuth();
//   const navigate = useNavigate();
//   const [form, setForm] = useState({ email: "", password: "" });
//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(false);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError("");
//     setLoading(true);
//     try {
//       await login(form.email, form.password);
//       navigate("/community");
//     } catch (err) {
//       setError(err.error || "Login failed. Please check your credentials.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <AuthLayout>
//       <h1 className="text-[32px] font-semibold text-gray-900 mb-2 font-body">Welcome back!</h1>
//       <p className="text-[15px] font-semibold text-black-500 mb-8 font-body">Enter your Credentials to access your account</p>

//       {error && <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-[13px] text-red-600">{error}</div>}

//       <form onSubmit={handleSubmit}>
//         <div className="mb-5">
//           <label className="block text-[14px] font-medium text-gray-900 mb-1.5">Email address</label>
//           <input type="email" placeholder="Enter your email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required
//             className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-[12px] text-[#000000] placeholder-[#000000] outline-none focus:border-primary transition-colors font-body" />
//         </div>
//         <div className="mb-4">
//           <div className="flex items-center justify-between mb-1.5">
//             <label className="block text-[14px] font-medium text-gray-900">Password</label>
//             <Link to="/forgot-password" className="text-[13px] text-primary font-medium hover:underline">forgot password</Link>
//           </div>
//           <input type="password" placeholder="Enter your password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required
//             className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-[12px] text-[#000000] placeholder-[#000000] outline-none focus:border-primary transition-colors font-body" />
//         </div>
//         <div className="flex items-center gap-2 mb-6">
//           <input type="checkbox" id="remember" className="w-4 h-4 rounded border-gray-300" />
//           <label htmlFor="remember" className="text-[13px] text-black font-body">Remember for 30 days</label>
//         </div>
//         <button type="submit" disabled={loading}
//           className="w-full py-3 bg-primary text-white rounded-lg font-semibold text-[15px] hover:bg-primary-dark transition-colors font-body disabled:opacity-60 mb-8">
//           {loading ? "Logging in..." : "Login"}
//         </button>
//       </form>

//       <p className="text-center text-[14px] font-medium text-black font-body">
//         Don't have an account?{" "}<Link to="/signup" className="text-[#1F3A60] font-semibold hover:underline">Sign Up</Link>
//       </p>
//     </AuthLayout>
//   );
// };

// export default LoginPage;
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import AuthLayout from "../components/auth/AuthLayout";

const LoginPage = () => {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // ====================================
  // Admin Credentials
  // ====================================

  const ADMIN_EMAIL = "admin@fa1thhook.com";
  const ADMIN_PASSWORD = "75&Y#j;5N|=b";

const handleSubmit = async (e) => {
  e.preventDefault();
 
  setError("");
  setLoading(true);
 
  try {

      // ====================================
      // ADMIN LOGIN
      // ====================================
 
      // if (
      //   form.email === ADMIN_EMAIL &&
      //   form.password === ADMIN_PASSWORD
      // ) {
      //   // ✅ Admin Login Save
      //   localStorage.setItem("isAdminLogin", "true");
      //   localStorage.setItem("adminEmail", ADMIN_EMAIL);
 
      //   navigate("/admin/dashboard");
 
      //   return;
      // }
 
      // ====================================
      // NORMAL USER LOGIN
      // ====================================
 
      const resultLogin = await login(form.email, form.password);
      const isUserAdmin=resultLogin?.user?.role=="admin";
      // console.log({resultLogin});
 
      if (isUserAdmin) {
          localStorage.setItem("isAdminLogin", "true");
          localStorage.setItem("adminEmail", resultLogin?.user?.email);
          navigate("/admin/dashboard");
          return;
      }
      localStorage.setItem("isAdminLogin", "false");
      navigate("/community");
  } catch (err) {
    localStorage.setItem("isAdminLogin", "false");
 
    setError(
      err?.error ||
        "Login failed. Please check your credentials."
    );
  } finally {
    setLoading(false);
  }
};


  return (
    <AuthLayout>
      {/* Heading */}
      <h1 className="text-[32px] font-semibold text-gray-900 mb-2 font-body">
        Welcome back!
      </h1>

      <p className="text-[15px] font-semibold text-black-500 mb-8 font-body">
        Enter your Credentials to access your account
      </p>

      {/* Error */}
      {error && (
        <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-[13px] text-red-600">
          {error}
        </div>
      )}

      {/* Form */}
      <form onSubmit={handleSubmit}>
        {/* Email */}
        <div className="mb-5">
          <label className="block text-[14px] font-medium text-gray-900 mb-1.5">
            Email address
          </label>

          <input
            type="email"
            placeholder="Enter your email"
            value={form.email}
            onChange={(e) =>
              setForm({
                ...form,
                email: e.target.value,
              })
            }
            required
            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-[12px] text-[#000000] placeholder-[#000000] outline-none focus:border-primary transition-colors font-body"
          />
        </div>

        {/* Password */}
        <div className="mb-4">
          <div className="flex items-center justify-between mb-1.5">
            <label className="block text-[14px] font-medium text-gray-900">
              Password
            </label>

            <Link
              to="/forgot-password"
              className="text-[13px] text-primary font-medium hover:underline"
            >
              forgot password
            </Link>
          </div>

          <input
            type="password"
            placeholder="Enter your password"
            value={form.password}
            onChange={(e) =>
              setForm({
                ...form,
                password: e.target.value,
              })
            }
            required
            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-[12px] text-[#000000] placeholder-[#000000] outline-none focus:border-primary transition-colors font-body"
          />
        </div>

        {/* Remember */}
        <div className="flex items-center gap-2 mb-6">
          <input
            type="checkbox"
            id="remember"
            className="w-4 h-4 rounded border-gray-300"
          />

          <label
            htmlFor="remember"
            className="text-[13px] text-black font-body"
          >
            Remember for 30 days
          </label>
        </div>

        {/* Submit */}
        <button
          type="submit"
          disabled={loading}
          className="w-full py-3 bg-primary text-white rounded-lg font-semibold text-[15px] hover:bg-primary-dark transition-colors font-body disabled:opacity-60 mb-8"
        >
          {loading ? "Logging in..." : "Login"}
        </button>
      </form>

      {/* Footer */}
      <p className="text-center text-[14px] font-medium text-black font-body">
        Don't have an account?{" "}
        <Link
          to="/signup"
          className="text-[#1F3A60] font-semibold hover:underline"
        >
          Sign Up
        </Link>
      </p>
    </AuthLayout>
  );
};

export default LoginPage;